import type { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, of, switchMap } from 'rxjs';
import { map } from 'rxjs/operators';

import { TellentOrganizationHttpClient } from '../tellent-organization.http';
import { AgreementsActions } from './agreements-state';

@Injectable({ providedIn: 'root' })
export class AgreementsEffects {
  private readonly actions = inject(Actions);
  private readonly httpClient = inject(TellentOrganizationHttpClient);

  public setAgreement = createEffect(() =>
    this.actions.pipe(
      ofType(AgreementsActions.setAgreement),
      switchMap(({ payload }) =>
        this.httpClient.setAgreement(payload).pipe(
          map(payload => AgreementsActions.setAgreementSuccess({ payload })),
          catchError((error: HttpErrorResponse) =>
            of(AgreementsActions.setAgreementFailed({ payload: error })),
          ),
        ),
      ),
    ),
  );

  public loadAgreement = createEffect(() =>
    this.actions.pipe(
      ofType(AgreementsActions.fetchOne),
      switchMap(({ payload: { id } }) =>
        this.httpClient.fetchAgreement(id).pipe(
          map(data => AgreementsActions.fetchOneSuccess({ payload: { data: { ...data, id } } })),
          catchError((error: HttpErrorResponse) =>
            of(AgreementsActions.fetchOneFailed({ payload: { error, id } })),
          ),
        ),
      ),
    ),
  );
}
